var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as LoginModalActions from '../../actions/auth/Login';
import * as FastJoin from '../../actions/auth/FastJoin';
import * as Signin from '../../actions/auth/SignIn';
import * as Registration from '../../actions/auth/Join';
import * as Signout from '../../actions/auth/SignOut';
import * as LoadAuth from '../../actions/auth/restore';
import * as MakeBetAction from '../../actions/makeBet';
import { GET_FREEBET } from '../../sagas/actions';
import { GET_QUICKBET_STATUS, GET_BET_STATUS } from '../../sagas/actions';
import { deleteAccessToken, getAccessToken } from '../../shared/tokenUtils';
var authenticated = false;
if (getAccessToken()) {
    authenticated = true;
}
var initialState = {
    authModalToggled: false,
    signInOngoing: false,
    isAuthenticating: false,
    user: {},
    authError: null,
    freebets: [],
    signInData: {},
    authData: undefined,
    rememberMe: true,
    authenticated: authenticated,
    onlineTranslation: false
};
var hash = window.location.hash;
var isMobileApp = hash === '#Android' || hash === '#iOS';
export default function auth(state, action) {
    if (state === void 0) { state = initialState; }
    if (action === void 0) { action = {}; }
    switch (action.type) {
        case Signin.REMEMBER_ME:
            return __assign(__assign({}, state), { rememberMe: !state.rememberMe });
        case Signin.DELETE_FETCH_ACTIVATE_EMAIL:
            return __assign(__assign({}, state), { authModalToggled: false, authError: null, successReset: false, signInData: {} });
        case Signin.SUCCESS_FETCH_ACTIVATE_EMAIL:
            return __assign(__assign({}, state), { signInData: __assign(__assign({}, state.signInData), { successReset: true }) });
        case GET_QUICKBET_STATUS.SUCCESS:
        case GET_BET_STATUS.SUCCESS:
        case MakeBetAction.SUCCESS_MAKE_QUICKBET:
        case MakeBetAction.SUCCESS_MAKE_BET:
            return state;
        case Signin.SUCCESS_FETCH_FREEBET:
        case GET_FREEBET.SUCCESS:
            if (Array.isArray(action.data)) {
                return __assign(__assign({}, state), { freebets: action.data });
            }
            return state;
        case LoginModalActions.OPEN_AUTH_MODAL:
            return __assign(__assign({}, state), { authModalToggled: true, onlineTranslation: !!(action.data && action.data.onlineTranslation) });
        case LoginModalActions.CLOSE_AUTH_MODAL:
            return __assign(__assign({}, state), { authModalToggled: false, onlineTranslation: false });
        case Signin.SIGNIN:
            var authData = isMobileApp ? action.data : undefined;
            return __assign(__assign({}, state), { isAuthenticating: true, authError: null, authData: authData });
        case LoadAuth.RESTORE:
            return __assign(__assign({}, state), { isAuthenticating: true, authError: null });
        case Signin.FAILURE_SIGNIN:
        case LoadAuth.FAILURE_RESTORE:
            deleteAccessToken();
            return __assign(__assign({}, state), { isAuthenticating: false, authError: null, authData: undefined, authenticated: false, user: {} });
        case LoadAuth.SUCCESS_RESTORE:
            return __assign(__assign({}, state), { isAuthenticating: false, authenticated: true, user: signUser(action.data) });
        case Signout.SIGNOUT:
            deleteAccessToken();
            return __assign(__assign({}, initialState), { authenticated: false, user: {} });
        case FastJoin.SUCCESS_FAST_CONFIRM_PHONE:
        case Registration.SUCCESS_CONFIRM_JOIN:
        case Signin.SUCCESS_SIGNIN:
            state = __assign(__assign({}, state), { isAuthenticating: false });
            var error = undefined;
            if (action.data.ResultState !== 0) {
                deleteAccessToken();
                switch (action.data.ResultState) {
                    case 1:
                        error = -2;
                        state = __assign(__assign({}, state), { signInData: action.data });
                        break;
                    case -2:
                        error = -1;
                        break;
                    case -3:
                        error = -5;
                        break;
                    case -5:
                        error = -5;
                        break;
                    default:
                        error = -1;
                        break;
                }
                state = __assign(__assign({}, state), { authError: error, authData: undefined, authenticated: false });
            }
            else {
                var token = action.data.token || action.data.Token;
                if (!sessionStorage.getItem('user-token') || token) {
                    (state.rememberMe ? localStorage : sessionStorage).setItem('user-token', token);
                }
                state = __assign(__assign({}, state), { authModalToggled: false, onlineTranslation: false, authError: null, authenticated: true, user: signUser(action.data) });
            }
            return state;
        default:
            return state;
    }
}
var signUser = function (data) {
    var malformed = data.malformed;
    var expired = data.expired || data.session_expired;
    var auth = data.auth || data.Auth;
    if (expired || malformed) {
        deleteAccessToken();
        return {};
    }
    return {
        accountId: auth.aid,
        accountNumber: auth.an,
        accountResourceId: auth.arid != null ? auth.arid : null,
        gamblerId: auth.gid,
        login: auth.l
    };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/authReducer.js